import React from 'react';
import './about.scss'
import { animateLeft, animateUp } from '../../settings/Animation';
import { Divider } from 'antd';
import my_photo from '../../img/i am.jpg'

const About = () => (
  <div className='content about-page'>
    <div className='divider-box'>
      <Divider className='title' orientation="left">
        <h3><span>02.</span>Про меня</h3>
      </Divider>
    </div>
    <div className='about-me'>
      <div className='my-info'>
        <p {...animateUp} data-aos-duration='600'>
          Меня зовут Рустам.Я являюсь фронтенд React разработчиком.Изучал программирование в социальных сетях,
          включая Udemy.com, Youtube.com.
          Я считают себя позитивным, стремительным, целеустремленным, ответственным.
          Знаю русский и английский.На русском могу свободно общаться.
        </p>
        <p {...animateUp} data-aos-duration='800'>Мои навыки:</p>
        <ul {...animateUp} data-aos-duration='1000'>
          <li>HTML5</li>
          <li>CSS3 / SASS</li>
          <li>Bootstrap</li>
          <li>Ant Design</li>
          <li>Javascript (ES6+)</li>
          <li>React js (Redux,Xook)</li>
          <li>Next js (Basic)</li>
          <li>Typescript (Basic)</li>
          <li>Git</li>
        </ul>
      </div>
      <div className='my-photo'>
        <img {...animateLeft} data-aos-duration='1000' src={my_photo} alt='' />
      </div>
    </div>
  </div>
);

export default About